import { Link, useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Image, { SLImage } from "./slimage"
import Navbar from "./navbar/navbar"
import styles from "./header.module.css"

const Header = ({ siteTitle }) => {
  const data = useStaticQuery(graphql`
    query {
      logoImage: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            src
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <header
      style={{
        background: `#005eb6`,
        marginBottom: `1.45rem`,
      }}
    >
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `1.45rem 1.0875rem`,
        }}
        className={styles.header}
      >
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          <div className={styles.siteName}>
            <div
              style={{
                maxWidth: `100px`,
                maxHeight: "100px",
              }}
            >
              <SLImage
                src={data.logoImage.childImageSharp.fluid.src}
                style={{ borderRadius: "50%", maxHeight: "100px" }}
              />
            </div>
            <h1 style={{ margin: 0, marginLeft: ".5em", fontSize: "1.5em" }}>
              {siteTitle}
            </h1>
          </div>
        </Link>
        <Navbar></Navbar>
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
